import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import { constants as subscriptionManagerConstants } from '@yola/subscription-manager-js';
import bowser from 'yola-bowser';
import upsell from '../../upsell';
import StickyTooltip from '../../blocks/components/sticky-tooltip';
import { PAGE_WRAPPER_CLASSNAME } from '../../blocks/constants/common';

const { PresetContainer, Tag } = designSystem;

const {
  hostingPackageFeatureNames: { PREMIUM_BUTTON_PRESETS },
} = subscriptionManagerConstants;

function ButtonPreset({
  id,
  title,
  contentHTML,
  isSelected = false,
  isPremium = false,
  editLabel = '',
  premiumLabel = '',
  onClick,
  onEditClick,
}) {
  const handleClick = () => onClick(id, isPremium);
  const handleEditClick = () => onEditClick(id);
  const isPresetAvailable =
    !isPremium || upsell.verifiers.isFeatureAvailable(PREMIUM_BUTTON_PRESETS);

  return (
    <StickyTooltip
      title={editLabel}
      customTargetSelector=".ws-ui-icon-button"
      scrollParentSelector={`.${PAGE_WRAPPER_CLASSNAME}`}
      isDisabled={bowser.mobile || bowser.tablet || !isPresetAvailable}
      lockPosition
    >
      <PresetContainer
        title={title}
        isSelected={isSelected}
        onClick={handleClick}
        {...(isPresetAvailable && { onEditClick: handleEditClick })}
      >
        <div
          /* eslint-disable yola/react/no-danger */
          dangerouslySetInnerHTML={{ __html: contentHTML }}
        />
        {!isPresetAvailable && (
          <div className="ws-button-preset__mark">
            <Tag label={premiumLabel} size="small" appearance="cta-secondary" />
          </div>
        )}
      </PresetContainer>
    </StickyTooltip>
  );
}

ButtonPreset.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  contentHTML: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
  isPremium: PropTypes.bool,
  editLabel: PropTypes.string,
  premiumLabel: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onEditClick: PropTypes.func.isRequired,
};

export default ButtonPreset;
